import { Ghost } from "lucide-react";

export const Footer = () => (
  <footer className="relative z-10 border-t border-[#A020F0]/30 bg-[#080808]/90 py-10 px-4 sm:px-8" data-testid="site-footer">
    <div className="max-w-6xl mx-auto flex flex-col items-center gap-6 text-center">
      <a href="#top" className="flex items-center gap-3 group" data-testid="footer-logo-link">
        <img
          src="/mascot.jpg"
          alt="$HALLOWIN logo"
          className="w-9 h-9 rounded-full ring-2 ring-[#FF6B00]/60 group-hover:ring-[#B6FF00] transition-all duration-300"
        />
        <span className="font-display font-bold tracking-widest text-sm text-white group-hover:text-[#B6FF00] transition-colors">
          $HALLOWIN
        </span>
      </a>
      <p className="mono text-[11px] sm:text-xs leading-relaxed text-purple-300/60 max-w-2xl" data-testid="footer-disclaimer">
        $HALLOWIN is a community-driven memecoin created for entertainment and Halloween vibes only. It is highly
        speculative, has no intrinsic value, and does not guarantee any financial returns. Nothing on this site is
        financial advice. Always do your own research and never spend candy money you can't afford to lose.
      </p>
      <div className="flex items-center gap-2 mono text-[10px] tracking-[0.3em] text-purple-400/50">
        <Ghost className="w-3.5 h-3.5 text-[#B6FF00]/60" />
        THIS HALLOWEEN, WE ALL WIN · SOLANA
        <Ghost className="w-3.5 h-3.5 text-[#A020F0]/60" />
      </div>
    </div>
  </footer>
);
